import type {LotteryGame, LotteryGameApi, LotteryGamesApiResponse} from "./lottery.types";

const slugify = (name: string): string =>
  name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+|-+$/g, "");

export const adaptLotteryGame = (api: LotteryGameApi): LotteryGame => {
  const name = api.name ?? "Juego";
  return {
    id: String(api.id ?? ""),
    slug: slugify(name),
    name,
    provider: api.provider?.name ?? "Coronando",
    gameType: api.game_type ?? "",
    logo: api.logo ?? null,
    minBet: typeof api.min_bet === "number" ? api.min_bet / 100 : null,
    maxBet: typeof api.max_bet === "number" ? api.max_bet / 100 : null,
    enabled: api.status === "active",
  };
};

export const adaptLotteryGames = (response: LotteryGamesApiResponse): LotteryGame[] => {
  const list = response?.data?.data;
  if (!Array.isArray(list)) return [];
  return list.filter(game => game.status === "active").map(adaptLotteryGame);
};
